<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="text-center" style="margin-bottom: 5px; margin-top: -3px">
            <a href="/app.html"><h3 class="text-white">
              RixPLS
            </h3>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center" style="margin-top: 35px">
      <form role="form" @submit.prevent="handleSubmit()">
        <card class="card-login card-plain" style="width: 322px">
          <div slot="header">
            <a href="/app.html"><div class="logo-container">
              <img src="/img/now-logo.png" alt="" />
            </div>
            </a>
          </div>
            <fg-input
              v-model="login"
              name="login"
              class="no-border form-control-lg"
              placeholder="Login"
              addon-left-icon="now-ui-icons users_circle-08"
              :error="apiValidationErrors.login"
            >
            </fg-input>

            <fg-input
              v-model="password"
              type="password"
              name="password"
              class="no-border form-control-lg"
              placeholder="Password"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              :error="apiValidationErrors.password"
            >
            </fg-input>
          <br>
            <n-button native-type="submit" type="primary" round block style="margin-left: 0">
              Get Started
            </n-button>
            <div class="pull-left">
              <h6>
                <a class="link footer-link" href="/register">
                  Create Account
                </a>
              </h6>
            </div>

            <div class="pull-right">
              <h6>
                <a href="/password/reset" class="link footer-link"
                  >Forgot password?</a
                >
              </h6>
            </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
export default {
  mixins: [formMixin],
  name: "login",
  data: () => ({
    login: "",
    password: "",
  }),
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
  },
  methods: {
    async handleSubmit() {
      const user = {
        data: {
          type: "token",
          attributes: {
            login: this.login,
            password: this.password,
          },
        },
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
      } catch (error) {
        await this.$store.dispatch("alerts/error", "Invalid credentials!");
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

a.footer-link:hover {
  text-decoration: underline;
  text-decoration-color: #f96332;
  text-decoration-thickness: 2px;
}

.form-control {
  font-size: 1.1rem!important;
}

.form-control:valid {
  padding-right: 0!important;
}

.form-control:invalid {
  padding-right: 0!important;
}

</style>
